<template>
  <nav class="min-h-24 mb-8">
    <slot></slot>
  </nav>
</template>
